import Customers from '../shared/Customers';

const AdminCustomers = () => {
  return <Customers isAdmin={true} />;
};

export default AdminCustomers;
